import React from "react";

const Msg = ({ msg }) => {
  let hClass = "msg";
  let iconClass = "fa";
  if (msg.type && msg.type === "success") {
    hClass += " success";
    iconClass += " fa-check-square-o";
  } else if (msg.type && msg.type === "error") {
    hClass += " error";
    iconClass += " fa-exclamation-triangle";
  } else if (msg.type) {
    hClass += " working";
    iconClass += " fa-cog fa-spin";
  } else {
    hClass += " hidden";
  }

  return (
    <p className={hClass}>
      <i className={iconClass} /> &nbsp;{msg.text}
    </p>
  );
};

export default Msg;



// WEBPACK FOOTER //
// ./src/Msg.js